import {
  addDays,
  addMonths,
  addWeeks,
  setDate,
  startOfWeek,
  subDays,
  subMonths,
  subWeeks,
} from 'date-fns'
import {
  CHART_TYPE_DAY,
  CHART_TYPE_MONTH,
  CHART_TYPE_WEEK,
  ChartTabProps,
} from './ChartUtil'
import { AppError, AppResponse } from '../Entities/BaseApi'
import DataTypes from '../Constants/DataTypes'
import { toDate } from './DateUtil'
import { ChartReq } from '../Services/GenkiApi'

export const getChartType = (chartTab: ChartTabProps) => {
  if (chartTab.tabType == CHART_TYPE_DAY) return 3
  if (chartTab.tabType == CHART_TYPE_WEEK) return 4
  if (chartTab.tabType == CHART_TYPE_MONTH) return 5
  return 3
}

export const getStartDate = (chartTab: ChartTabProps, selectedDate: number) => {
  if (chartTab.tabType == CHART_TYPE_DAY)
    return subDays(selectedDate, 3).setHours(0, 0, 0, 0) / 1000
  if (chartTab.tabType == CHART_TYPE_WEEK)
    return subDays(selectedDate, 3 * 7).setHours(0, 0, 0, 0) / 1000
  if (chartTab.tabType == CHART_TYPE_MONTH) {
    let newMonthDate = subMonths(selectedDate, 3).setDate(1)
    let newDate = new Date(newMonthDate)
    return newDate.setHours(0, 0, 0, 0) / 1000
  }
  return 0
}

export const getEndDateRaw = (
  chartTab: ChartTabProps,
  selectedDate: number
) => {
  if (chartTab.tabType == CHART_TYPE_DAY)
    return addDays(selectedDate, 3).setHours(23, 59, 59, 0) / 1000
  if (chartTab.tabType == CHART_TYPE_WEEK)
    return addDays(selectedDate, 3 * 7).setHours(23, 59, 59, 0) / 1000
  if (chartTab.tabType == CHART_TYPE_MONTH) {
    let newMonth = addMonths(selectedDate, 4)
    let newDay = subDays(newMonth, 1)
    return newDay.setHours(23, 59, 59, 0) / 1000
  }
  return 0
}
export const getNowRound10MinInSecond = (): number => {
  let now = new Date()
  let minute = ((now.getMinutes() + 10) / 10) * 10
  now.setMinutes(minute)
  let numberF = now.getTime() / 1000
  return Math.floor(numberF)
}

export const getEndDate = (chartTab: ChartTabProps, selectedDate: number) => {
  let end = getEndDateRaw(chartTab, selectedDate)
  let now = getNowRound10MinInSecond()
  if (end > now) return now
  return end
}

export const prepareRequest = (
  chartTab: ChartTabProps,
  selectedDate: number
) => {
  return {
    chart_type: getChartType(chartTab),
    data_type: 34,
    start_date: getStartDate(chartTab, selectedDate),
    end_date: getEndDate(chartTab, selectedDate),
  }
}

export const isAppResponse = (response: any): response is AppResponse => {
  return 'status' in response && 'body' in response
}

export const isAppError = (error: any): error is AppError => {
  return 'errorCode' in error
}

//========== CHART ==========
export const prepareChartRequest = (
  chartTab: ChartTabProps,
  endAt: number,
  dataType: number = DataTypes.AMM
): ChartReq => {
  return {
    chart_type: getChartType(chartTab),
    data_type: dataType,
    start_date: getStartDateChart(chartTab, endAt),
    end_date: getEndDateChart(chartTab, endAt),
  }
}

export const getStartDateChart = (
  chartTab: ChartTabProps,
  endAt: number
): number => {
  if (chartTab.tabType == CHART_TYPE_DAY)
    return subDays(endAt, 7 - 1).setHours(0, 0, 0, 0) / 1000
  if (chartTab.tabType == CHART_TYPE_WEEK) {
    let startD = subWeeks(endAt, 7 - 1)
    let startOfWeekD = startOfWeek(startD, { weekStartsOn: 0 })
    let startOfDayAt = startOfWeekD.setHours(0, 0, 0, 0)
    return startOfDayAt / 1000
  }
  if (chartTab.tabType == CHART_TYPE_MONTH) {
    let startD = subMonths(endAt, 7 - 1)
    let startOfMonthD = setDate(startD, 1)
    let startOfDayAt = startOfMonthD.setHours(0, 0, 0, 0)
    return startOfDayAt / 1000
  }
  return 0
}

export const getEndDateChartRaw = (
  chartTab: ChartTabProps,
  endAt: number
): number => {
  let endD = toDate(endAt)
  if (chartTab.tabType == CHART_TYPE_DAY) {
    return endD.setHours(23, 59, 59, 0) / 1000
  }
  if (chartTab.tabType == CHART_TYPE_WEEK) {
    let nextWeekD = addWeeks(endD, 1)
    let startDayNextWeekD = startOfWeek(nextWeekD, { weekStartsOn: 0 })
    let endDayCurrentWeekD = subDays(startDayNextWeekD, 1)
    let endOfDayAt = endDayCurrentWeekD.setHours(23, 59, 59, 0)
    return endOfDayAt / 1000
  }
  if (chartTab.tabType == CHART_TYPE_MONTH) {
    let nextMonthD = addMonths(endAt, 1)
    let startDayNextMonthD = setDate(nextMonthD, 1)
    let endDayCurrentMonthD = subDays(startDayNextMonthD, 1)
    let endOfDateAt = endDayCurrentMonthD.setHours(23, 59, 59, 0)
    return endOfDateAt / 1000
  }
  return 0
}

export const getEndDateChart = (
  chartTab: ChartTabProps,
  endAt: number
): number => {
  let end = getEndDateChartRaw(chartTab, endAt)
  let now = getNowRound10MinInSecond()
  if (end > now) return now
  return end
}
